import styled from "styled-components";

export type WrapperProps = {
  backgroundColor: string;
  configMode: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  justify-content: center;
  width: 100%;
  ${(props) => (props.configMode ? "" : "min-height: 100vh")};
  height: 100%;
  background-color: ${(props) => props.backgroundColor};
`;
